export default function infoView() {
  return {
    activeTab: 0,
    tabs: [],

    init() {
      // Component initialized
    },

    open(detail) {
      // Update store state
      this.$store.infodrawer.title = detail.title;
      this.$store.infodrawer.content = detail.content;
      this.$store.infodrawer.type = detail.type;
      this.$store.infodrawer.isOpen = true;

      // Auto-detect if this is a tabbed drawer based on tabs data
      if (detail.tabs) {
        this.setupTabs(detail);
      } else {
        // Clear tabs for non-tabbed content
        this.tabs = [];
        this.activeTab = 0;
        this.renderContent(detail);
      }
    },

    close() {
      this.$store.infodrawer.isOpen = false;
      this.activeTab = 0;
    },

    setupTabs(detail) {
      // Parse tabs string into array of objects
      if (detail.tabs) {
        const tabsString = detail.tabs;
        const tabParts = tabsString.split("|||");
        this.tabs = [];

        for (let i = 0; i < tabParts.length; i += 2) {
          if (tabParts[i] && tabParts[i + 1]) {
            this.tabs.push({
              title: tabParts[i],
              content: tabParts[i + 1]
            });
          }
        }
      }

      // Set title
      const titleElement = document.getElementById("info-view-title");
      if (titleElement) {
        titleElement.textContent = "Product Details";
      }
    },

    getProductData() {
      // Get product data from metafields or data attributes
      const productElement = document.querySelector("[data-product-id]");
      if (!productElement) return {};

      return {
        tab1Content: productElement.dataset.tab1Content || "",
        tab2Content: productElement.dataset.tab2Content || ""
      };
    },

    renderContent(detail) {
      const contentContainer = document.getElementById("info-view-content");
      if (!contentContainer) {
        return;
      }

      // Set details title to the title element
      const titleElement = document.getElementById("info-view-title");
      if (titleElement) {
        titleElement.textContent = detail.title;
      }

      // Set details content to the content element
      const contentElement = document.getElementById("info-view-content");
      if (contentElement) {
        contentElement.innerHTML = detail.content;
      }
    }
  };
}
